import type { SVGProps } from "react";
const GithubSVG = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.3"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M12 12h.01"></path>
    <path d="M16 6V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"></path>
    <path d="M22 13a18.15 18.15 0 0 1-20 0"></path>
    <rect width="20" height="14" x="2" y="6" rx="2"></rect>
  </svg>
);
export default GithubSVG;
